// Images
require.context("../images", true)

// CSS
import "stylesheets/decidim/conferences/conferences.scss"
